import * as React from 'react';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, } from 'material-ui/Table';
import api from '../../api';
export var UserTable = function (_a) {
    var users = _a.users, onSelection = _a.onSelection;
    return React.createElement(Table, { selectable: false },
        React.createElement(TableHeader, { displaySelectAll: false, adjustForCheckbox: false },
            React.createElement(TableRow, null,
                React.createElement(TableHeaderColumn, null),
                React.createElement(TableHeaderColumn, null, "V\u00E1rakozik (db)"),
                React.createElement(TableHeaderColumn, null, "Elk\u00E9sz\u00FClt (db)"),
                React.createElement(TableHeaderColumn, null, "Tervezett id\u0151 (\u00F3ra)"),
                React.createElement(TableHeaderColumn, null, "Elt\u00F6lt\u00F6tt id\u0151 (\u00F3ra)"),
                React.createElement(TableHeaderColumn, null, "Terhelts\u00E9g (%)"),
                React.createElement(TableHeaderColumn, null))),
        React.createElement(TableBody, { displayRowCheckbox: false }, users.map(function (i) {
            return React.createElement(TableRow, { key: i.user.id },
                React.createElement(TableRowColumn, null,
                    React.createElement(Avatar, { style: { marginRight: '5px' }, src: "" + api.defaults.baseURL + i.user.avatar }),
                    " ",
                    i.user.name),
                React.createElement(TableRowColumn, null, i.statistic.todo),
                React.createElement(TableRowColumn, null, i.statistic.finished),
                React.createElement(TableRowColumn, null, i.statistic.timePlanned),
                React.createElement(TableRowColumn, null, i.statistic.timeSpent),
                React.createElement(TableRowColumn, null, i.statistic.workload),
                React.createElement(TableRowColumn, null,
                    React.createElement(FlatButton, { primary: true, onClick: function (e) { return onSelection(i); } }, "FELADATOK")));
        })));
};



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/UserTable.tsx
// module id = 796
// module chunks = 0